export const getDevice = () =>{
    const userAgent = navigator.userAgent;
    if (/Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(userAgent)) {
        return 'mobile';
    } else if (/Macintosh|Windows NT|Linux/i.test(userAgent)) {
        return 'desktop';
    }
}